"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var prosemirror_state_1 = require("prosemirror-state");
var prosemirror_history_1 = require("prosemirror-history");
var prosemirror_transform_1 = require("prosemirror-transform");
var const_1 = require("../../const");
var util_1 = require("../../libs/util");
var prose_util_1 = require("../../libs/prose-util");
var prosemirror_model_1 = require("prosemirror-model");
var basic_ctrl_1 = require("../basic-ctrl");
var shortcut_plugin_1 = require("../text-shortcut/shortcut-plugin");
var appendKeepMark = function (command) { return function (state, dispatch) {
    return command(state, function (tr) {
        var marks = state.storedMarks || (state.selection.$to.parentOffset && state.selection.$from.marks());
        if (marks)
            tr.ensureMarks(marks);
        dispatch && dispatch(tr);
    });
}; };
var isInList = function (state) {
    var itemType = state.doc.type.schema.nodes.list_item;
    var _a = state.selection, $from = _a.$from, $to = _a.$to;
    if (!itemType || $from.parent.type !== itemType || $to.parent.type !== itemType)
        return false;
    return true;
};
var getListPos = function (state, from, to) {
    var listRes = [];
    state.doc.nodesBetween(from, to, function (node, pos) {
        if (node.type.name === const_1.NODE_NAME.LIST)
            listRes.push(pos + 1);
        return !node.isLeaf;
    });
    return listRes;
};
var checkAndMergeList = function (tr, pos) {
    var res = false;
    if (!isInList(tr))
        return res;
    var $pos = tr.doc.resolve(pos);
    var beforePos = pos;
    var afterPos = pos;
    if ($pos.depth) {
        beforePos = $pos.before();
        afterPos = $pos.after();
    }
    var $before = tr.doc.resolve(beforePos);
    var beforeNode = $before.nodeBefore;
    var beforeNodeAfter = $before.nodeAfter;
    var beforeNodePos = 0;
    if (beforeNode)
        beforeNodePos = beforePos - beforeNode.nodeSize;
    if (beforeNode && beforeNodeAfter && beforeNode.type === beforeNodeAfter.type && prosemirror_transform_1.canJoin(tr.doc, beforePos)) {
        tr.join(beforePos);
        var nodeBefore = tr.doc.nodeAt(beforeNodePos);
        if (nodeBefore)
            afterPos = beforeNodePos + nodeBefore.nodeSize;
        res = true;
    }
    var $after = tr.doc.resolve(afterPos);
    var afterNode = $after.nodeBefore;
    var afterNodeAfter = $after.nodeAfter;
    if (afterNode && afterNodeAfter && afterNode.type === afterNodeAfter.type && prosemirror_transform_1.canJoin(tr.doc, afterPos)) {
        tr.join(afterPos);
        res = true;
    }
    return res;
};
exports.checkAndMergeList = checkAndMergeList;
var doLiftList = function (tr, pos) {
    var range = tr.doc.resolve(pos).blockRange();
    if (!range)
        return tr;
    if (range.depth) {
        var target = prosemirror_transform_1.liftTarget(range);
        if (target === null || target === undefined)
            return tr;
        tr.lift(range, target ? target : range.depth - 1);
    }
    var $resPos = tr.doc.resolve(tr.mapping.map(range.start));
    if (!$resPos.depth || $resPos.parent.type.spec.role !== 'list') {
        if (!$resPos.nodeAfter)
            return tr;
        tr.setBlockType($resPos.pos, $resPos.pos + $resPos.nodeAfter.nodeSize, tr.doc.type.contentMatch.defaultType);
    }
    return tr;
};
exports.doLiftList = doLiftList;
// lift之后的start继承之前列表的序号
var fixListStart = function (tr) {
    if (isInList(tr))
        return;
    var nodeBefore = tr.doc.resolve(tr.selection.$from.before()).nodeBefore;
    var afterPos = tr.selection.$from.after();
    var nodeAfter = tr.doc.resolve(afterPos).nodeAfter;
    if (!nodeBefore || !nodeAfter || nodeBefore.type !== nodeAfter.type)
        return;
    if (nodeBefore.type.spec.role !== 'list' || !nodeBefore.attrs.start)
        return;
    var start = parseInt(nodeBefore.attrs.start, 10);
    nodeBefore.content.forEach(function (child) {
        if (child.type !== nodeBefore.type)
            start++;
    });
    tr.setNodeMarkup(afterPos, undefined, { start: start });
};
var liftListItem = function (state, dispatch) {
    if (!isInList(state))
        return false;
    var tr = state.tr;
    var _a = state.selection, $from = _a.$from, $to = _a.$to;
    // 上浮列表
    var listRes = getListPos(state, $from.pos, $to.pos).reverse();
    listRes.forEach(function (pos) { return doLiftList(tr, pos); });
    fixListStart(tr);
    dispatch && dispatch(tr);
    return tr;
};
exports.liftListItem = liftListItem;
// 在行首时判断是清除列表格式
var liftListItemAtHead = function (state, dispatch) {
    return state.selection.empty && !state.selection.$from.nodeBefore && liftListItem(state, dispatch);
};
exports.liftListItemAtHead = liftListItemAtHead;
var splitListItem = function (state, dispatch) {
    if (!dispatch || !isInList(state))
        return false;
    var tr = state.tr;
    var selection = state.selection, schema = state.schema;
    var $from = selection.$from, $to = selection.$to;
    var list_item = schema.nodes.list_item;
    if ($from.parent.content.size === 0) {
        liftListItem(state, dispatch);
        return true;
    }
    tr = tr.delete($from.pos, $to.pos);
    var attrs = $from.node().attrs;
    dispatch(tr
        .split($from.pos, 1, [
        {
            type: list_item,
            attrs: attrs
        }
    ])
        .scrollIntoView());
    return true;
};
exports.splitListItem = splitListItem;
var splitListItemKeepMarks = function (state, dispatch) {
    return splitListItem(state, dispatch &&
        (function (tr) {
            var marks = state.storedMarks || (state.selection.$to.parentOffset && state.selection.$from.marks());
            if (marks)
                tr.ensureMarks(marks);
            dispatch(tr);
        }));
};
exports.splitListItemKeepMarks = splitListItemKeepMarks;
var checkOutMaxNestedLevel = function (state) {
    var BSState = basic_ctrl_1.BSControlKey.getState(state);
    if (!BSState)
        return false;
    var maxLevel = BSState.listNestedLevel;
    if (!maxLevel)
        return false;
    var $from = state.selection.$from;
    var depth = $from.depth - 1;
    while (maxLevel && depth) {
        var parent_1 = $from.node(depth--);
        if (parent_1.type.spec.role === 'list')
            maxLevel--;
    }
    return !maxLevel;
};
var sinkListItem = function (state, dispatch) {
    if (!dispatch || !isInList(state))
        return false;
    if (checkOutMaxNestedLevel(state))
        return true;
    var _a = state.selection, $from = _a.$from, $to = _a.$to;
    var type = state.schema.nodes[const_1.NODE_NAME.BULLET_LIST];
    var tr = state.tr;
    var listRes = getListPos(state, $from.pos, $to.pos);
    listRes.reverse().forEach(function (pos) {
        var $nFrom = tr.doc.resolve(pos);
        if ($nFrom.depth > 1)
            type = $nFrom.node(-1).type;
        if (!type)
            return;
        var range = $nFrom.blockRange();
        tr.wrap(range, [{ type: type }]);
        checkAndMergeList(tr, pos);
    });
    dispatch(tr.scrollIntoView());
    return true;
};
exports.sinkListItem = sinkListItem;
var insertBreak = function (state, dispatch) {
    var selection = state.selection;
    if (selection.$cursor && selection.empty) {
        var marks = util_1.Utils.getStoreMarks(state);
        dispatch(state.tr.insert(selection.from, state.schema.nodes.break.create()).ensureMarks(marks));
        return true;
    }
    return false;
};
exports.insertBreak = insertBreak;
var deleteSelection = function (state, dispatch) {
    var _a = state.selection, empty = _a.empty, from = _a.from, $from = _a.$from;
    if (empty)
        return false;
    var tr = state.tr.deleteSelection();
    var textOffset = $from.parentOffset;
    var newSelection = prosemirror_state_1.Selection.near(tr.doc.resolve(from - 1 > 0 ? (textOffset ? from : from - 1) : 1));
    tr = tr.setSelection(newSelection).scrollIntoView();
    dispatch && dispatch(tr);
    return true;
};
exports.deleteSelection = deleteSelection;
/**
 * 段落首位按下backspace，选中拥有sylCard特殊标记的节点
 * 跳到包含可输入元素的最后一位
 * 合并可合并的的内容
 */
var selectBefore = function (state, dispatch) {
    var $cursor = state.tr.selection.$cursor;
    if (!$cursor || $cursor.parentOffset || !$cursor.parent.content.size) {
        return false;
    }
    var $cut = prose_util_1.findCutBefore($cursor);
    if (!$cut)
        return false;
    var before = $cut.nodeBefore;
    if (!before)
        return false;
    if (before.type.spec.sylCard) {
        var newSelection = prosemirror_state_1.NodeSelection.create(state.tr.doc, $cut.pos - before.nodeSize);
        dispatch && dispatch(state.tr.setSelection(newSelection));
        return true;
    }
    // 纠正多级列表的选区
    if (before.type.spec.role === 'list') {
        var _a = prose_util_1.getPrevNodeLastTextBlock($cut), node = _a.node, pos = _a.pos;
        if (node && dispatch) {
            var tr = state.tr.deleteRange(pos + node.nodeSize - 1, $cursor.pos);
            dispatch(tr.setSelection(prosemirror_state_1.TextSelection.create(tr.doc, pos + node.nodeSize - 1)).scrollIntoView());
            return true;
        }
    }
    return false;
};
exports.selectBefore = selectBefore;
var splitBlock = function (state, dispatch) {
    var ref = state.selection;
    var $from = ref.$from, $to = ref.$to;
    if (state.selection instanceof prosemirror_state_1.NodeSelection && state.selection.node.isBlock) {
        if (!$from.parentOffset || !prosemirror_transform_1.canSplit(state.doc, $from.pos)) {
            return false;
        }
        dispatch && dispatch(state.tr.split($from.pos).scrollIntoView());
        return true;
    }
    if (!$from.parent.isBlock) {
        return false;
    }
    // 段落在无内容时重新创建，其余类型在最后就
    var needCreate = $from.parent.type.name === const_1.NODE_NAME.P ? !$from.parent.textContent : $to.parentOffset === $to.parent.content.size;
    var tr = state.tr;
    if (state.selection instanceof prosemirror_state_1.TextSelection) {
        tr.deleteSelection();
    }
    var defaultType = $from.depth === 0 ? undefined : $from.node(-1).contentMatchAt($from.indexAfter(-1)).defaultType;
    var types = needCreate && defaultType ? [{ type: defaultType }] : undefined;
    var can = prosemirror_transform_1.canSplit(tr.doc, tr.mapping.map($from.pos), 1, types);
    if (!types && !can && prosemirror_transform_1.canSplit(tr.doc, tr.mapping.map($from.pos), 1, defaultType && [{ type: defaultType }])) {
        types = [{ type: defaultType }];
        can = true;
    }
    if (can && defaultType) {
        tr.split(tr.mapping.map($from.pos), 1, types);
        if (!needCreate &&
            !$from.parentOffset &&
            $from.parent.type !== defaultType &&
            $from.node(-1).canReplace($from.index(-1), $from.indexAfter(-1), prosemirror_model_1.Fragment.from(defaultType.create()))) {
            tr.setNodeMarkup(tr.mapping.map($from.before()), defaultType);
        }
    }
    dispatch && dispatch(tr.scrollIntoView());
    return true;
};
exports.splitBlock = splitBlock;
var splitBlockKeepMarks = appendKeepMark(splitBlock);
exports.splitBlockKeepMarks = splitBlockKeepMarks;
var deleteZeroChar = function (state, dispatch) {
    var tr = state.tr;
    var $from = state.selection.$from;
    if (!$from.nodeBefore)
        return false;
    var zeroChars = [];
    var deleteLen = 0;
    var getMatchRes = function ($pos, node) {
        if (!node)
            return;
        var matchRes = node.textContent.match(/\u200B+$/);
        if (matchRes) {
            deleteLen = matchRes[0].length;
            zeroChars.push({ from: $pos.pos - matchRes[0].length, to: $pos.pos });
        }
    };
    getMatchRes($from, $from.nodeBefore);
    var $posBefore = tr.doc.resolve($from.pos - deleteLen - 1);
    getMatchRes($posBefore, $posBefore.nodeBefore);
    zeroChars.forEach(function (_a) {
        var from = _a.from, to = _a.to;
        return tr.delete(from, to);
    });
    dispatch && dispatch(tr);
    return false;
};
exports.deleteZeroChar = deleteZeroChar;
var clearFormatAtHead = function (state, dispatch) {
    var _a = state.selection, $from = _a.$from, empty = _a.empty;
    if (!empty)
        return false;
    if ($from.pos !== 1 || $from.depth !== 1)
        return false;
    var tr = state.tr, doc = state.doc;
    var parentNode = $from.node();
    if (!parentNode.isTextblock || parentNode.childCount)
        return false;
    var defaultNodeType = doc.type.contentMatch.defaultType;
    dispatch && dispatch(tr.setBlockType($from.before(), $from.after(), defaultNodeType));
    return true;
};
exports.clearFormatAtHead = clearFormatAtHead;
var undo = function (state, dispatch) {
    return [shortcut_plugin_1.undoTextShortcut, prosemirror_history_1.undo].some(function (fn) { return fn(state, dispatch); });
};
exports.undo = undo;
//# sourceMappingURL=behavior.js.map